module.exports = __webpack_public_path__ + "img/cat-1.f62fac28.svg";